import {Directive, ElementRef, OnDestroy, OnInit} from '@angular/core';
import {select, Store} from '@ngrx/store';
import {AppState} from '../../app.store';
import {Subscription} from 'rxjs';

@Directive({
  selector: '[appLoading]'
})
export class LoadingDirective implements OnInit, OnDestroy {
  isLoading$: Subscription;

  constructor(private el: ElementRef, private store: Store<AppState>) {
    console.log('directive created');
  }

  ngOnInit(): void {
    this.isLoading$ =
      this.store.pipe(
        select((state: AppState) => state.loading.active)
      ).subscribe(
        n => {
          console.log('directive ', n);
          this.el.nativeElement.style.display = n === 0 ? 'none' : '';
        }
      );
  }

  ngOnDestroy(): void {
    this.isLoading$.unsubscribe();
  }



}
